import React from 'react';
import { View, Image, ScrollView, Text, Dimensions } from 'react-native';
import { connect } from 'react-redux';

import { fetchSpecificJourney, isSubscribed, fetchInProgressJourneys, fetchCompletedJourneys } from "../../redux/actions";

import Colors from "../../constants/Colors";
import {SpinnerControl, Card, Button, ButtonWithSpinner, SpinnerDialogue, InformationDialogue} from "../../components";
import {subToJourney} from "./api/methods/subscribeToJourney";
import NavBar from "../../components/NavBar";

class JourneyDetailsScreen extends React.Component {

    state = {
        isSubscribing: false,
        showErrorModal: false,
        showSuccessModal: false,
    }

    handleSubscription = async () => {

        if (this.state.isSubscribing) return;
        this.setState({ isSubscribing: true })

        try {
            await subToJourney(this.props.userId, this.props.currentJourney.id);
            await this.props.fetchInProgressJourneys();
            await this.props.fetchCompletedJourneys();

            this.setState({ showSuccessModal: true })

        } catch (e) {
            console.log(e);
            this.setState({ showErrorModal: true })
        }

        this.setState({ isSubscribing: false })
    }

    componentDidMount() {
        const uniqueId = this.props.history.location.state.journeyId;
        this.props.fetchSpecificJourney(uniqueId);
    }

    render() {

        const uniqueId = this.props.history.location.state.journeyId;
        const { height, width } = Dimensions.get('window');
        const { currentJourney, fetchingCurrentJourney } = this.props;

        const isSubscribed = this.props.isSubscribed(uniqueId);

        // noinspection PointlessBooleanExpressionJS
        return (
            <NavBar title={"Informação"}>

                <SpinnerDialogue
                    isModalVisible={this.state.isSubscribing}
                    onClose={() => this.setState({ isSubscribing: false }) }
                    isFinished={!this.state.isSubscribing}
                    titleProps={"Fazendo Inscrição!"}
                    messageProps={`Estamos fazendo a sua inscrição!`}
                />

                <InformationDialogue
                    isModalVisible={this.state.showErrorModal}
                    titleText={"Erro!"}
                    descriptionText={"Aconteceu um erro ao fazer a inscrição! Tente novamente mais tarde."}
                    onClose={() => this.setState({ showErrorModal: false })}
                />

                <InformationDialogue
                    isModalVisible={this.state.showSuccessModal}
                    titleText={"Sucesso!"}
                    descriptionText={"Sua inscrição foi realizada com sucesso!"}
                    buttons={[
                        {
                            text: "Voltar",
                            onPress: () => {
                                this.props.history.goBack();
                            }
                        },
                        {
                            text: "Continuar",
                            onPress: () => {
                                this.props.history.push(`/journey/hub?journeyId=${uniqueId}`)
                            }
                        }
                    ]}
                />

                <SpinnerControl
                    isFetching={this.props.fetchingCurrentJourney}
                    text={"Carregando!"}
                    textPropsStyle={{ color: Colors.spinnerNoBackgroundTextColor }}
                />

                {
                    (currentJourney !== null) &&
                    <View style={{ alignItems: 'center' }} >

                        <Card containerStyle={{ width: 600, alignItems: 'center' }}>

                            <Image
                                style={{ height: 300, width: 500, borderRadius: 8, marginBottom: 8 }}
                                source={{ uri: `data:image/jpeg;base64,${currentJourney.thumbnail}` }}
                                resizeMode={'contain'}
                            />

                            <Text style={{ textAlign: 'center', fontSize: 22, fontWeight: 'bold', marginBottom: 8, color: 'white' }}>
                                { currentJourney.title }
                            </Text>

                            <Text style={{ width: '100%', textAlign: 'left', fontSize: 18, marginBottom: 8, color: 'white',  }}>
                                { currentJourney.description }
                            </Text>

                            <Text style={{ width: '100%', textAlign: 'left', fontSize: 18, marginBottom: 20, color: 'white',  }}>
                                { `Elementos de Aprendizagem: ${ currentJourney.items.length}` }
                            </Text>

                            {
                                isSubscribed === false &&
                                    <ButtonWithSpinner
                                        text={'Fazer Inscrição'}
                                        onPress={this.handleSubscription}
                                        containerPropsStyle={{
                                            backgroundColor: Colors.buttonColor,
                                            borderColor: Colors.buttonColor,
                                            height: 30,
                                            borderRadius: 4
                                        }}
                                        textPropsStyle={{ fontSize: 18, fontWeight: 'bold' }}
                                        isLoading={this.state.isSubscribing}
                                    />
                            }

                            {
                                isSubscribed === true &&
                                    <Button
                                        text={"Você já está inscrito! \n Acessar!"}
                                        onPress={() => this.props.history.push(`/journey/hub?journeyId=${uniqueId}`) }
                                        containerPropsStyle={{
                                            backgroundColor: Colors.buttonColor,
                                            borderColor: Colors.buttonColor,
                                            height: 60,
                                            borderRadius: 4
                                        }}
                                        textPropsStyle={{ fontSize: 18, fontWeight: 'bold', textAlign: 'center' }}
                                    />
                            }
                        </Card>
                    </View>
                }
            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        userId: state.user.userId,
        currentJourney: state.journey.currentJourney,
        fetchingCurrentJourney: state.journey.fetchingCurrentJourney,
    }
}

export default connect(mapStateToProps, { fetchSpecificJourney, isSubscribed, fetchInProgressJourneys, fetchCompletedJourneys })(JourneyDetailsScreen);
